import FJConfig from '../config/FJConfig';
import WaveSurfer from 'wavesurfer.js';
import FJLocalStore from '../store/FJLocalStore';
import FJCanvasUtil from './FJCanvasUtil';
import FJFileHandleUtil from './FJFileHandleUtil';
import FJMathUtil from './FJMathUtil';
import FJRequirementsUtil from './FJRequirementsUtil';
import FJStringUtil from './FJStringUtil';
import FJAppConstant from '../constants/FJAppConstant.js';
import FJNetworkStore from '../store/FJNetworkStore.js';
import FJConstant from '../constants/FJConstant.js';
import FJDomUtil from './FJDomUtil.js';

let _browser = null;
let _AudioContext = null;
let isNeedGenerateInImageToImage = false;
let _baseTimeForId = Date.now();

const obj = {
    /**
     * @desc 获取当前浏览器
     * @return {string}
     */
    getBrowser: function () {
        if (_browser) {
            return _browser;
        }
        const userAgentDataBrowserData = { 'Google Chrome': 'Chrome', Opera: 'Opera', 'Microsoft Edge': 'Edge' };
        // 使用新的方式获取
        let __getBrowserUseNewMethods = () => {
            let browser = '';
            if (navigator && navigator.userAgentData) {
                const userAgentData = navigator.userAgentData;
                const isMobile = userAgentData.mobile ? '.Mobile' : '';
                const brands = userAgentData.brands;
                let keys = Object.keys(userAgentDataBrowserData);
                for (let i = 0; i < brands.length; i++) {
                    const brand = brands[i].brand;
                    let index = keys.indexOf(brand);
                    if (index !== -1) {
                        let key = keys[index];
                        browser = userAgentDataBrowserData[key] + isMobile;
                        break;
                    }
                }
            }
            return browser;
        };
        // 使用老的方式获取
        let __getBrowserUseOldMethods = () => {
            let Sys = {};
            let ua = navigator.userAgent.toLowerCase();
            let s;
            let isMobile = '';

            // eslint-disable-next-line no-unused-expressions, no-cond-assign
            (s = ua.match(/rv:([\d.]+)\) like gecko/))
                ? (Sys.ie = s[1])
                : // eslint-disable-next-line no-cond-assign
                  (s = ua.match(/msie ([\d.]+)/))
                  ? (Sys.ie = s[1])
                  : // eslint-disable-next-line no-cond-assign
                    (s = ua.match(/edge\/([\d.]+)/))
                    ? (Sys.edge = s[1])
                    : // eslint-disable-next-line no-cond-assign
                      (s = ua.match(/edg\/([\d.]+)/))
                      ? (Sys.edge = s[1])
                      : // eslint-disable-next-line no-cond-assign
                        (s = ua.match(/firefox\/([\d.]+)/))
                        ? (Sys.firefox = s[1])
                        : // eslint-disable-next-line no-cond-assign
                          (s = ua.match(/opera.([\d.]+)/))
                          ? (Sys.opera = s[1])
                          : // eslint-disable-next-line no-cond-assign
                            (s = ua.match(/opr\/([\d.]+)/))
                            ? (Sys.opera = s[1])
                            : // eslint-disable-next-line no-cond-assign
                              (s = ua.match(/chrome\/([\d.]+)/))
                              ? (Sys.chrome = s[1])
                              : // eslint-disable-next-line no-cond-assign
                                (s = ua.match(/version\/([\d.]+).*safari/))
                                ? (Sys.safari = s[1])
                                : 0;

            if (ua.match(/mobile/)) isMobile = '.Mobile';

            if (Sys.ie) return 'IE' + isMobile;
            else if (Sys.edge) return 'Edge' + isMobile;
            else if (Sys.firefox) return 'FF' + isMobile;
            else if (Sys.opera) return 'Opera' + isMobile;
            else if (Sys.safari) return 'Safari' + isMobile;
            else if (Sys.chrome) return 'Chrome' + isMobile;
            else return '';
        };

        let browser = __getBrowserUseNewMethods();
        if (!browser) browser = __getBrowserUseOldMethods();
        _browser = browser;
        return browser;
    },
    addEvent: function (element, event, handler, useCapture = false) {
        if (!element) {
            return;
        }
        if (element.addEventListener) {
            element.addEventListener(event, handler, useCapture);
        } else if (element.attachEvent) {
            element.attachEvent('on' + event, handler);
        }
    },
    removeEvent: function (element, event, handler, useCapture = false) {
        if (!element) {
            return;
        }
        if (element.removeEventListener) {
            element.removeEventListener(event, handler, useCapture);
        } else if (element.detachEvent) {
            element.detachEvent('on' + event, handler);
        }
    },
    throttle: function (fn, delay) {
        let valid = true;
        return function () {
            if (valid) {
                valid = false;
                setTimeout(() => {
                    fn.apply(this, arguments);
                    valid = true;
                }, delay);
            }
        };
    },
    debounce: function (fn, delay) {
        let timer = null;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(() => {
                fn.apply(this, arguments);
            }, delay);
        };
    },
    getQueryString: function (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },
    getCurrentUrl: function () {
        let lange = FJLocalStore.currentTag();
        let url = '';
        if (lange === 'en' || lange === 'it') {
            url = FJConfig.serverPath;
        } else {
            url = FJConfig.serverPath + '/' + lange + '/';
        }
        return url;
    },
    /**
     * @description 改变地址栏链接
     * @param {*} url
     */
    changeLocation: function (url) {
        window.history.replaceState({ id: 0 }, document.title, url);
    },
    getPathSuffix: function (path) {
        return path.substr(path.lastIndexOf('.') + 1).trim();
    },
    copyText(text) {
        return new Promise(resolve => {
            if (navigator.clipboard?.writeText) {
                return resolve(navigator.clipboard.writeText(text));
            }
            // 创建输入框
            const textarea = document.createElement('textarea');
            document.body.appendChild(textarea);
            // 隐藏此输入框
            textarea.style.position = 'absolute';
            textarea.style.clip = 'rect(0 0 0 0)';
            // 赋值
            textarea.value = text;
            // 选中
            textarea.select();
            // 复制
            document.execCommand('copy', true);
            textarea.remove();
            return resolve(true);
        });
    },
    removeQueryParam(paramKey) {
        const _getQueryParams = () => {
            let params = {};
            location.search
                .substr(1)
                .split('&')
                .forEach(function (item) {
                    let s = item.split('='),
                        k = s[0],
                        v = s[1] && decodeURIComponent(s[1]);
                    (params[k] = params[k] || []).push(v);
                });
            return params;
        };
        let queryParams = _getQueryParams();
        delete queryParams[paramKey];

        // 重新构建查询字符串
        let newQuery = Object.keys(queryParams)
            .map(key => {
                if (Array.isArray(queryParams[key])) {
                    return queryParams[key]
                        .map(value => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                        .join('&');
                }
                return `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`;
            })
            .join('&');

        // 更新浏览器历史记录和URL显示
        history.pushState({}, '', location.pathname + (newQuery ? '?' + newQuery : ''));
    },
    getValueInRange: function (value, min, max) {
        value = value < min ? min : value;
        value = value > max ? max : value;
        return value;
    },

    isPanelArea: function (e, object) {
        if (!e) {
            return false;
        }
        let point = {
            x: e.clientX,
            y: e.clientY,
        };

        try {
            // 避免小数计算导致误差
            const offset = 1;
            const clientRect = object.getBoundingClientRect();
            let rect = {
                x: clientRect.left - offset,
                y: clientRect.top - offset,
                width: clientRect.width + offset,
                height: clientRect.height + offset,
            };

            return FJMathUtil.isPointInRect(point, rect);
        } catch (e) {
            return false;
        }
    },

    poll: function (fn, timeout) {
        setTimeout(function () {
            fn && fn();
            FJUtil.poll(fn, timeout);
        }, timeout);
    },
    sleep: ms => {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    getChromeVersion() {
        const arr = navigator.userAgent.split(' ');
        let chromeVersion = '';
        for (let i = 0; i < arr.length; i++) {
            if (/chrome/i.test(arr[i])) chromeVersion = arr[i];
        }
        if (chromeVersion) {
            return Number(chromeVersion.split('/')[1].split('.')[0]);
        } else {
            return 0;
        }
    },
    couldUseWebCodecs(type) {
        if (!window.VideoEncoder || !window.VideoDecoder) {
            return false;
        }

        const chromeVersion = FJUtil.getChromeVersion();
        if (chromeVersion < 92) {
            return false;
        }

        const maxSupportChromeVersion = 109;
        const maxSupportDecodeChromeVersion = Infinity;
        const maxSupportEncodeChromeVersion = Infinity;

        if (type === 'decode') {
            return chromeVersion <= maxSupportDecodeChromeVersion;
        } else if (type === 'encode') {
            return chromeVersion <= maxSupportEncodeChromeVersion;
        } else {
            return chromeVersion <= maxSupportChromeVersion;
        }
    },
    /**
     * @description 判断是否是手机端访问
     * @returns {boolean}
     */
    isMobile: function () {
        const ua = navigator.userAgent.toLowerCase();
        return !!ua.match(/mobile/);
    },
    forbidEvent: function (e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
    },
    /**
     * @desc 判断url是否跨域
     * @param {string} url
     * @returns {boolean}
     */
    isCrossOrigin(url) {
        try {
            const origin = new URL(url).origin;
            if (!origin || origin === 'null') return false;
            return origin !== window.location.origin;
        } catch (e) {
            return false; // 返回false以处理无效的URL
        }
    },

    /**
     * @desc 将标准UTC时区的时间转为当前时区时间
     * @param {string} time 标准时间
     * @returns {number}
     */
    convertToCurrentTimezone(time = '2024-09-20 09:59:19') {
        const date = new Date(time);

        // 转为标准时间
        const utcTime = date.getTime();

        // 标准时间转地区时间
        const currentTime = new Date(utcTime - new Date().getTimezoneOffset() * 60000 * 2);
        const formattedTime = currentTime.toISOString().slice(0, 19).replace('T', ' ');

        return formattedTime;
    },

    /**
     * @desc 深拷贝
     * @param {any} obj
     * @returns {any}
     */
    deepClone: function (obj) {
        if (typeof obj !== 'object' || obj === null) {
            return obj;
        }

        let newObj;
        if (obj instanceof Array) {
            newObj = [];
            for (let i = 0; i < obj.length; i++) {
                newObj[i] = this.deepClone(obj[i]);
            }
        } else if (obj instanceof ImageData) {
            newObj = new ImageData(new Uint8ClampedArray(obj.data), obj.width, obj.height);
        } else {
            newObj = {};
            for (let key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    newObj[key] = this.deepClone(obj[key]);
                }
            }
        }

        return newObj;
    },

    /**
     * @description 判断value是否为undefined
     * @param value
     * @return {boolean}
     */
    isUndefined: function (value) {
        return value === void 0;
    },
    valueOfInterval(value, min, max) {
        let result = 0;
        result = value < min ? min : value;
        result = result > max ? max : result;
        return result;
    },

    /**
     * @param time
     * @param keepMs 是否保留毫秒
     * @param mDigit 分钟位数
     * @param msDigit 毫秒位数
     * @param hasAutoHour 是否在超过60分钟后自动转化为小时
     * @returns {string|string}
     */
    formatTime: function (time, keepMs, mDigit, msDigit, hasAutoHour = false) {
        if (!time && time !== 0) return mDigit === 2 ? '00:00' : '0:00';
        if (typeof time !== 'number') time = Number(time);
        if (isNaN(time)) return mDigit === 2 ? '00:00' : '0:00';

        time = time.toFixed(2);
        let m = Math.floor(time / 60);
        let s = keepMs ? Math.floor(time % 60) : Math.round(time % 60); // 显示毫秒的地方s要用向下取整
        // 小时
        let hour = 0;
        if (s === 60) {
            // 四舍五入可能造成s为60
            m += 1;
            s = 0;
        }
        if (s < 10) s = '0' + s;

        if (hasAutoHour && m >= 60) {
            hour = Math.floor(m / 60);
            m = m % 60;
        }
        if (m < 10 && mDigit === 2) m = '0' + m;

        if (keepMs) {
            time = (Math.round(time * 10) / 10).toFixed(2).toString();
            let ms = time.substr(time.lastIndexOf('.') + 1, msDigit || 2);
            if (hour !== 0) {
                return `${hour}:${m}:${s}.${ms}`;
            }
            return `${m}:${s}.${ms}`;
        } else {
            if (hour !== 0) {
                return `${hour}:${m}:${s}`;
            }
            return `${m}:${s}`;
        }
    },

    isVideoGenerator: function () {
        return FJConfig.appType === FJAppConstant.AI_VIDEO_GENERATOR;
    },

    isAudioGenerator: function () {
        return FJConfig.appType === FJAppConstant.AI_AUDIO_GENERATOR;
    },

    setLocalStorage: function () {
        const communicationKey = localStorage.getItem('communicationKey');
        localStorage.setItem('communicationKey', communicationKey + 1);
    },

    deepEqual: function (a, b) {
        if (a === b) return true;
        if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;
        if (a.constructor !== b.constructor) return false;
        return JSON.stringify(a) === JSON.stringify(b);
    },

    /**
     * 比较两个时间是否相等
     * @param {Number} time1 - 第一个时间
     * @param {Number} time2 - 第二个时间
     * @returns {Boolean} - 如果时间相等返回true，否则返回false
     */
    compareTimes: function (time1, time2, precision = 0.01) {
        return Math.abs(time1 - time2) < precision;
    },

    /**
     * @desc 获取音频上下文
     * @returns {AudioContext}
     */
    getAudioContext: function () {
        if (_AudioContext) {
            return _AudioContext;
        } else {
            // @ts-ignore
            _AudioContext = new (window.AudioContext || window.webkitAudioContext)();
            return _AudioContext;
        }
    },

    /**
     * @desc 获取音频采样率
     * @returns {number}
     */
    getAudioSampleRate: function () {
        const sr = this.getAudioContext().sampleRate;
        return sr <= 44100 ? sr : 48000;
    },
    getAudioWave: function (audioUrl, isGradient = false, config) {
        return new Promise((resolve, reject) => {
            const isBlobURL = url => {
                // Blob URL 格式为: blob:域名/uuid
                const blobPattern = /^blob:https?:\/\/.+/;
                return blobPattern.test(url);
            };

            let waveDom = document.createElement('div');
            waveDom.style.setProperty('width', '370px');
            waveDom.style.setProperty('width', '20px');

            document.body.appendChild(waveDom);
            try {
                const configInfo = {
                    container: waveDom,
                    height: 20,
                    width: 370,
                    waveColor: '#a3a9b4',
                    cursorColor: '#130d0d',
                    interact: false,
                    barWidth: 1,
                    barGap: 2,
                    cursorWidth: 0,
                    ...config,
                };

                if (isGradient) {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    const gradient = ctx.createLinearGradient(0, 0, 327, 0);
                    gradient.addColorStop(0, '#FF47D0');
                    gradient.addColorStop(1, '#FF822C');
                    configInfo.waveColor = gradient;
                }

                let wave = WaveSurfer.create({
                    ...configInfo,
                });

                wave.on('ready', () => {
                    wave.exportImage('image/png', 1).then(res => {
                        resolve(res[0]);
                        document.body.removeChild(waveDom);
                        waveDom = null;
                    });
                });

                wave.on('error', e => {
                    reject(e);
                    document.body.removeChild(waveDom);
                    waveDom = null;
                });

                wave.load(isBlobURL(audioUrl) ? audioUrl : this.getReloadNewUrl(audioUrl));
            } catch (e) {
                console.log(e);
                document.body.removeChild(waveDom);
                waveDom = null;
                reject(e);
            }
        });
    },
    /**
     * @description 检查网络状态
     * @returns {Promise<boolean>}
     */
    checkNetworkStatus: function () {
        return fetch('https://www.google.com/favicon.ico', { method: 'HEAD', mode: 'no-cors' })
            .then(() => true)
            .catch(() => false);
    },
    /**
     * @desc 将数组的某一个元素提升到第一位
     * @param arr
     * @param index
     * @return {*}
     */
    elevateArrayFromIndex(arr, index) {
        if (index < 0 || index >= arr.length) {
            throw new Error('Invalid index');
        }
        const element = arr.splice(index, 1)[0];
        arr.unshift(element);
    },
    /**
     * @description 返回当前鼠标的位置
     * @param {Object} e
     * @return {{x: *, y: *}}
     */
    calcCursorPoint: function (e) {
        return { x: e.clientX, y: e.clientY };
    },

    /**
     * @description 生成id
     * @param {boolean} hash
     * @param {number} length
     * @return {string}
     */
    createSimpleId() {
        _baseTimeForId++;
        return _baseTimeForId.toString();
    },
    // 保留2位小数
    toFixed: function (value, fractionDigits = 2) {
        if (!value) return 0;
        return Number(value.toFixed(fractionDigits));
    },

    setIsNeedGenerateInImageToImage: function (bool) {
        isNeedGenerateInImageToImage = bool;
    },

    getIsNeedGenerateInImageToImage: function () {
        return isNeedGenerateInImageToImage;
    },

    hasDiscount: function () {
        let tempData = window.user_limited_time_coupon_info;
        if (tempData) {
            const { expired_at, status } = tempData;
            const nowTime = new Date().getTime();
            const expireTime = expired_at * 1000;
            const diffTime = expireTime - nowTime;
            if (status === 1) {
                // 已经使用
                return false;
            } else {
                if (diffTime > 0) {
                    // 折扣中
                    return true;
                } else {
                    // 过期
                    return false;
                }
            }
        } else {
            // 还没有触发倒计时
            if (FJUtil.getAB() === 'A') {
                return false;
            } else {
                return true;
            }
        }
    },
    /**
     * 精准计算多个浮点数相乘
     * @param numbers 数字组成的数组
     */
    preciseMultiply: function (numbers) {
        // 剔除不是数字的元素
        const filterNumbers = numbers.filter(item => typeof item === 'number');
        if (filterNumbers.length === 0) {
            return 0; // 没有输入数时返回 0
        }

        // 计算所有浮点数的小数位数总和
        let totalDecimalPlaces = 0;
        const scaledNumbers = filterNumbers.map(number => {
            const decimalPlaces = (number.toString().split('.')[1] || '').length;
            totalDecimalPlaces += decimalPlaces;
            return Number(number.toString().replace('.', ''));
        });

        // 将放大的整数相乘
        const multipliedResult = scaledNumbers.reduce((acc, curr) => acc * curr, 1);

        // 将结果缩小回去
        return multipliedResult / Math.pow(10, totalDecimalPlaces);
    },

    /**
     * @description 格式化数字为千分位
     * @param {number | string} number
     * @returns
     */
    formatNumberThousandth: function (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    wait: function (seconds = 0.3) {
        return new Promise(resolve => {
            const timer = setTimeout(() => {
                clearTimeout(timer);
                resolve();
            }, seconds * 1000);
        });
    },

    /**
     * 获取a/b测试客户端身份
     * @return string 返回A或者B
     */
    getAB: function () {
        let id = window.localStorage.getItem('AB-ID');
        if (!id) {
            id = window.Math.floor(window.Math.random() * 10000) % 2 ? 'A' : 'B';
            window.localStorage.setItem('AB-ID', id);
        }
        return id;
    },

    /**
     * @desc 检查任务状态
     * @returns {Function}
     */
    checkTaskStatus: async function (successCallbackData, eventId) {
        const result = await FJNetworkStore.getTaskState(eventId);
        if (!result) {
            return 'error';
        }

        switch (result.job_state) {
            case 'succeeded':
                if (result.out_put) {
                    const list = result.out_put;
                    const data = await FJUtil.parseList(list, {
                        prompt,
                        type: FJConstant.CREATIONS,
                        isUploadWaterMark: FJConfig.appType !== FJAppConstant.FACE_SWAP,
                    });
                    successCallbackData && successCallbackData(data);
                }
                return 'succeeded';
            case 'waiting':
            case 'processing':
                return 'processing';
            case 'failed':
            case 'canceled':
                return 'failed';
            default:
                return 'error';
        }
    },
};
const FJUtil = {
    ...obj,
    ...FJFileHandleUtil,
    ...FJRequirementsUtil,
    ...FJMathUtil,
    ...FJStringUtil,
    ...FJCanvasUtil,
    ...FJDomUtil,
};
export default FJUtil;
